import { EnvMicroStaffOrganization } from "lib-klab-core";

export const envStaffOrganizationLocal: EnvMicroStaffOrganization = {
  host: "",
  apiBasePath: "/erp-ms-organization",
  useMocks: false,
};

export const envStaffOrganizationDev: EnvMicroStaffOrganization = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-organization",
  useMocks: false,
};

export const envStaffOrganizationProd: EnvMicroStaffOrganization = {
  host: "https://gatewayapi.erp.inclub.world",
  apiBasePath: "/ms-organization",
  useMocks: false,
};
